import React from 'react'
import { Popover , Overlay } from 'react-bootstrap'
import './PopoverStyle.css'

const PopoverTooltip = (props) => {
    const {
        target,
        show,
        showTitle,
        placement
    } = props
    
    if(!target.getAttribute){
        return null
    }

    return (
        <Overlay
            show={show}
            target={target}
            placement={placement || "right"}
        >
            <Popover>
                {
                    showTitle ? 
                    <Popover.Header as="h3">Purpose</Popover.Header>
                    :
                    null
                }
                <Popover.Body>
                    { target.getAttribute("data-tooltip") }
                </Popover.Body>
            </Popover>
        </Overlay>
    )
}

export default PopoverTooltip
